var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89234 19.7661C4.44279 19.7661 0.00927734 15.3326 0.00927734 9.88306C0.00927734 4.43351 4.44279 0 9.89234 0C15.3419 0 19.7754 4.43351 19.7754 9.88306C19.7754 15.3326 15.3419 19.7661 9.89234 19.7661ZM9.89234 1.87357C5.47587 1.87357 1.88284 5.4666 1.88284 9.88306C1.88284 14.2995 5.47587 17.8925 9.89234 17.8925C14.3088 17.8925 17.9018 14.2995 17.9018 9.88306C17.9018 5.4666 14.3088 1.87357 9.89234 1.87357ZM23.7166 23.7256C24.0824 23.3598 24.0824 22.7666 23.7166 22.4008L19.5245 18.2087C19.1586 17.8428 18.5654 17.8428 18.1996 18.2087C17.8338 18.5745 17.8338 19.1677 18.1996 19.5335L22.3917 23.7256C22.5746 23.9085 22.8144 24 23.0542 24C23.2939 24 23.5336 23.9085 23.7166 23.7256Z",
    fill: "#004E5E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.07092849695485436929e0c5fdbc2af0.svg";
export { ForwardRef as ReactComponent };